export default "__VITE_ASSET__CpMtI7fX__"